import EntirePageLoading from './EntirePageLoading';

export default EntirePageLoading;
